import React, {useState, useEffect, useContext} from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import './gallery.css';
import {LoadingContext} from "../../composants/loadingContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages, faExpand, faImage } from "@fortawesome/free-solid-svg-icons";

const Gallery = () => {
  const {loading, setLoading} = useContext(LoadingContext);
  
  useEffect(() => {
    document.title='Galerie Photos - YouthFP';
    setLoading(false);
  }, []);
  
  const images = [
    {original: "/img/1.jpg", thumbnail: "/img/1.jpg"},
    {original: "/img/1.png", thumbnail: "/img/1.png"},
    {original: "/img/10.jpg", thumbnail: "/img/10.jpg"},
    {original: "/img/100.jpg", thumbnail: "/img/100.jpg"},
    {original: "/img/101.jpg", thumbnail: "/img/101.jpg"},
    {original: "/img/102.jpg", thumbnail: "/img/102.jpg"},
    {original: "/img/103.jpg", thumbnail: "/img/103.jpg"},
    {original: "/img/104.jpg", thumbnail: "/img/104.jpg"},
    {original: "/img/105.jpg", thumbnail: "/img/105.jpg"},
    {original: "/img/106.jpg", thumbnail: "/img/106.jpg"},
    {original: "/img/107.jpg", thumbnail: "/img/107.jpg"},
    {original: "/img/108.jpg", thumbnail: "/img/108.jpg"},
    {original: "/img/109.jpg", thumbnail: "/img/109.jpg"},
    {original: "/img/11.jpg", thumbnail: "/img/11.jpg"},
    {original: "/img/110.jpg", thumbnail: "/img/110.jpg"},
    {original: "/img/111.jpg", thumbnail: "/img/111.jpg"},
    {original: "/img/112.jpg", thumbnail: "/img/112.jpg"},
    {original: "/img/113.jpg", thumbnail: "/img/113.jpg"},
    {original: "/img/116.jpg", thumbnail: "/img/116.jpg"},
    {original: "/img/117.jpg", thumbnail: "/img/117.jpg"},
    {original: "/img/118.jpg", thumbnail: "/img/118.jpg"},
    {original: "/img/119.jpg", thumbnail: "/img/119.jpg"},
    {original: "/img/12.jpg", thumbnail: "/img/12.jpg"},
    {original: "/img/120.jpg", thumbnail: "/img/120.jpg"},
    {original: "/img/121.jpg", thumbnail: "/img/121.jpg"},
    {original: "/img/122.jpg", thumbnail: "/img/122.jpg"},
    {original: "/img/123.jpg", thumbnail: "/img/123.jpg"},
    {original: "/img/124.jpg", thumbnail: "/img/124.jpg"},
    {original: "/img/13 (2).jpg", thumbnail: "/img/13 (2).jpg"},
    {original: "/img/13.jpg", thumbnail: "/img/13.jpg"},
    {original: "/img/14.jpg", thumbnail: "/img/14.jpg"},
    {original: "/img/147.jpg", thumbnail: "/img/147.jpg"},
    {original: "/img/15.jpg", thumbnail: "/img/15.jpg"},
    {original: "/img/150.jpg", thumbnail: "/img/150.jpg"},
    {original: "/img/159.jpg", thumbnail: "/img/159.jpg"},
    {original: "/img/194.jpg", thumbnail: "/img/194.jpg"},
    {original: "/img/2.jpg", thumbnail: "/img/2.jpg"},
    {original: "/img/201.jpg", thumbnail: "/img/201.jpg"},
    {original: "/img/206.jpg", thumbnail: "/img/206.jpg"},
    {original: "/img/22.png", thumbnail: "/img/22.png"},
    {original: "/img/24.jpg", thumbnail: "/img/24.jpg"},
    {original: "/img/29.jpg", thumbnail: "/img/29.jpg"},
    {original: "/img/3.jpg", thumbnail: "/img/3.jpg"},
    {original: "/img/31.jpg", thumbnail: "/img/31.jpg"},
    {original: "/img/34.jpg", thumbnail: "/img/34.jpg"},
    {original: "/img/35.jpg", thumbnail: "/img/35.jpg"},
    {original: "/img/39.jpg", thumbnail: "/img/39.jpg"},
    {original: "/img/4.jpg", thumbnail: "/img/4.jpg"},
    {original: "/img/40.png", thumbnail: "/img/40.png"},
    {original: "/img/41.jpg", thumbnail: "/img/41.jpg"},
    {original: "/img/43.jpg", thumbnail: "/img/43.jpg"},
    {original: "/img/44.jpg", thumbnail: "/img/44.jpg"},
    {original: "/img/45.jpg", thumbnail: "/img/45.jpg"},
    {original: "/img/47.jpg", thumbnail: "/img/47.jpg"},
    {original: "/img/49.jpg", thumbnail: "/img/49.jpg"},
    {original: "/img/5.jpg", thumbnail: "/img/5.jpg"},
    {original: "/img/52.jpg", thumbnail: "/img/52.jpg"},
    {original: "/img/57.jpg", thumbnail: "/img/57.jpg"},
    {original: "/img/59.jpg", thumbnail: "/img/59.jpg"},
    {original: "/img/6.jpg", thumbnail: "/img/6.jpg"},
    {original: "/img/63.jpg", thumbnail: "/img/63.jpg"},
    {original: "/img/7.jpg", thumbnail: "/img/7.jpg"},
    {original: "/img/71.jpg", thumbnail: "/img/71.jpg"},
    {original: "/img/79.jpg", thumbnail: "/img/79.jpg"},
    {original: "/img/8(2).jpg", thumbnail: "/img/8(2).jpg"},
    {original: "/img/8.jpg", thumbnail: "/img/8.jpg"},
    {original: "/img/89.jpg", thumbnail: "/img/89.jpg"},
    {original: "/img/9.jpg", thumbnail: "/img/9.jpg"},
    {original: "/img/90.jpg", thumbnail: "/img/90.jpg"},
    {original: "/img/92.jpg", thumbnail: "/img/92.jpg"},
    {original: "/img/96.jpg", thumbnail: "/img/96.jpg"},
    {original: "/img/97.jpg", thumbnail: "/img/97.jpg"},
    {original: "/img/98.jpg", thumbnail: "/img/98.jpg"},
    {original: "/img/99.jpg", thumbnail: "/img/99.jpg"},
    {original: "/img/bolivar.jpg", thumbnail: "/img/bolivar.jpg"},
    {original: "/img/cathy.jpg", thumbnail: "/img/cathy.jpg"},
    {original: "/img/cnjc.jpg", thumbnail: "/img/cnjc.jpg"},
    {original: "/img/ndongo.jpg", thumbnail: "/img/ndongo.jpg"},
    {original: "/img/patrick.jpg", thumbnail: "/img/patrick.jpg"}
  ];

  return (
      <>
          <div className="relative bg-gradient-to-br from-pink-600 via-purple-500 to-indigo-600 text-white py-20 overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
                  <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
              </div>
              
              <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="text-center">
                      <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 shadow-2xl">
                          <FontAwesomeIcon icon={faImages} className="text-4xl" />
                      </div>
                      <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">
                          Galerie Photos
                      </h1>
                      <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-6">
                          Découvrez nos moments forts en images
                      </p>
                      <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full">
                          <FontAwesomeIcon icon={faImage} className="text-pink-300" />
                          <span className="text-lg font-semibold">{images.length}</span>
                          <span className="text-white/80">photos disponibles</span>
                      </div>
                  </div>
              </div>
          </div>

          <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="mb-8 bg-white rounded-2xl shadow-lg p-6 border-l-4 border-purple-500">
                      <div className="flex items-start gap-4">
                          <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
                              <FontAwesomeIcon icon={faExpand} className="text-white text-xl" />
                          </div>
                          <div>
                              <h3 className="text-lg font-bold text-gray-800 mb-2">
                                  Mode Plein Écran
                              </h3>
                              <p className="text-gray-600 text-sm">
                                  Cliquez sur l'icône plein écran pour une expérience immersive.
                              </p>
                          </div>
                      </div>
                  </div>

                  <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200 p-4">
                      <ImageGallery 
                          showNav={true} 
                          showFullscreenButton={true} 
                          showPlayButton={true}
                          thumbnailPosition={"bottom"} 
                          items={images}
                          slideInterval={3000}
                          slideDuration={450}
                      />
                  </div>

                  <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="bg-white rounded-xl shadow-md p-6 text-center border-t-4 border-purple-500">
                          <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-4">
                              <FontAwesomeIcon icon={faImages} className="text-3xl text-purple-600" />
                          </div>
                          <h3 className="text-3xl font-bold text-gray-800 mb-2">{images.length}</h3>
                          <p className="text-gray-600 font-medium">Photos au total</p>
                      </div>
                      
                      <div className="bg-white rounded-xl shadow-md p-6 text-center border-t-4 border-pink-500">
                          <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full mb-4">
                              <FontAwesomeIcon icon={faImage} className="text-3xl text-pink-600" />
                          </div>
                          <h3 className="text-3xl font-bold text-gray-800 mb-2">HD</h3>
                          <p className="text-gray-600 font-medium">Haute Qualité</p>
                      </div>
                      
                      <div className="bg-white rounded-xl shadow-md p-6 text-center border-t-4 border-indigo-500">
                          <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-4">
                              <FontAwesomeIcon icon={faExpand} className="text-3xl text-indigo-600" />
                          </div>
                          <h3 className="text-3xl font-bold text-gray-800 mb-2">Plein Écran</h3>
                          <p className="text-gray-600 font-medium">Disponible</p>
                      </div>
                  </div>
              </div>
          </div>
      </>
  );
};

export default Gallery;
